import { create } from 'zustand'

export type ApiStatus = 'healthy' | 'down' | 'unknown'

type SyncStore = {
  pending: number
  lastCompletedAt: number | null
  apiStatus: ApiStatus
  apiLastCheckedAt: number | null
  startSync: (label?: string) => () => void
  setApiStatus: (status: ApiStatus) => void
}

const useSyncStore = create<SyncStore>()((set) => ({
  pending: 0,
  lastCompletedAt: null,
  apiStatus: 'unknown',
  apiLastCheckedAt: null,
  startSync: () => {
    set((state) => ({
      pending: state.pending + 1,
    }))

    let finished = false

    return () => {
      if (finished) {
        return
      }

      finished = true

      set((state) => {
        const nextPending = Math.max(0, state.pending - 1)

        return {
          pending: nextPending,
          lastCompletedAt:
            nextPending === 0 ? Date.now() : state.lastCompletedAt,
        }
      })
    }
  },
  setApiStatus: (status) =>
    set({ apiStatus: status, apiLastCheckedAt: Date.now() }),
}))

export default useSyncStore
